export default __webpack_public_path__ + "static/media/intermedio_4.43048e13.jpg";